import { useContext } from "react"

import { Activities } from "~/pages/Admin/Ingestion/Activities/components/Activities"
import { ActivityCreation } from "~/pages/Admin/Ingestion/Activities/components/ActivityCreation"
import { OpChainContext } from "~/pages/Admin/Ingestion/OpChains/store/op-chain-context"

export function ActivitiesAdminWrapper() {
  const { activities } = useContext(OpChainContext)

  return (
    <>
      <ActivityCreation />
      <Activities activities={activities} />
    </>
  )
}
